export default "__VITE_ASSET__Cs0EUhOy__"